"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoutRequest = void 0;
var LogoutRequest = /** @class */ (function () {
    function LogoutRequest() {
    }
    return LogoutRequest;
}());
exports.LogoutRequest = LogoutRequest;
;
//# sourceMappingURL=logout.request.js.map